import React, { Component } from 'react';
import IconComponent from '../portal/iconComponent';

const UserFullname = ({active, fullName}) => {

    const userIconClassName = active ? 'active-user-icon': 'none-active-user-icon';
    const userIconTitle = active ? '': 'User is disabled';

    return <div className='user-name-column users-grid library-name-link ellipsis'>
                {<IconComponent iconClassName={userIconClassName} title={userIconTitle}/>}
                <span className='user-full-name' title={fullName}>
                    {fullName}
                </span>
            </div>
}

export default UserFullname;


// WEBPACK FOOTER //
// ./src/components/users/userFullName.jsx